import { render, staticRenderFns } from "./IndicadoresHistoricoGastosVentas.vue?vue&type=template&id=5fb57ef2&"
import script from "./IndicadoresHistoricoGastosVentas.vue?vue&type=script&lang=js&"
export * from "./IndicadoresHistoricoGastosVentas.vue?vue&type=script&lang=js&"
import style0 from "./IndicadoresHistoricoGastosVentas.vue?vue&type=style&index=0&id=5fb57ef2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports